import { Waypoint } from 'react-waypoint'
import React, { useCallback, useContext, useEffect, useRef } from 'react'
import './styles.scss'
import { useSpring, animated as a } from 'react-spring'
import { LocaleContext } from '../../contexts/locale'

import landschaft from 'images/cover/landschaft_mittelgrund.png?sizes=330w+660w+880w+1100w+1760w+2000w'
import heerMittelgrund from 'images/cover/heer_mittelgrund.png?sizes=330w+660w+880w+1100w+1760w+2000w'
import heerVordergrund from 'images/cover/heer_vordergrund.png?sizes=330w+660w+880w+1100w+1760w+2000w'
import felsen from 'images/cover/felsen.png?sizes=330w+660w+880w+1100w+1760w+2000w'
import daenerys from 'images/cover/drache_daenerys.png?sizes=330w+660w+880w+1760w+2000w'

export function Cover({
  onLeave
}: {
  onLeave: (event: Waypoint.CallbackArgs) => void
}) {
  const locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  const coverSegment = useRef<HTMLDivElement>(null)
  const [{ scrollTop }, set] = useSpring(() => ({
    scrollTop: 0,
    immediate: true
  }))
  const [daenerysProps, setDaenerys] = useSpring(() => ({
    transform: 'translate3d(-100%, -330%, -10px) scale(0.2)',
    config: { mass: 3, tension: 180, friction: 120 }
  }))
  const textPosition = scrollTop.interpolate(
    val => `translateZ(${val * -120}px) translateY(${val * 70}%)`
  )

  const onScroll = useCallback(e => {
    if (e.target.scrollingElement && coverSegment.current) {
      set({
        scrollTop:
          e.target.scrollingElement.scrollTop /
          coverSegment.current.clientHeight
      })
    }
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: false })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div className='ui vertical segment' id='cover' ref={coverSegment}>
      <a.div
        className='ui text container'
        style={{
          transform: scrollTop.interpolate(val => `translateY(${val * 20}%)`),
          opacity: scrollTop
            .interpolate({ range: [0, 0.333, 1], output: [0, 1, 1] })
            .interpolate(val => 1 - val)
        }}
      >
        <Waypoint
          scrollableAncestor={window}
          onLeave={() => {
            setDaenerys({
              transform: 'translate3d(60%, -150%, 60px) scale(1.2)'
            })
          }}
        />
        <h1
          className='ui centered header'
          style={{ maskImage: `url(${require('images/distressed.png')})` }}
        >
          {messages.TITLE}
        </h1>
        <div className='ta lead'>{messages.SUB_TITLE}</div>

        <Waypoint scrollableAncestor={window} onLeave={onLeave} />
      </a.div>

      <div className={'image holder'}>
        <a.div
          style={{
            transform: scrollTop.interpolate(val => `translateY(${val * 75}%)`)
          }}
          id='background-holder'
        />

        <a.img
          style={{
            transform: scrollTop.interpolate(
              val =>
                `translateZ(${20 - val * 20}px) translateY(${-20 + val * 33}%)`
            )
          }}
          id='landschaft'
          src={landschaft.sources['880w']}
          srcSet={landschaft.srcSet}
          sizes='110vw'
          alt=''
        />

        <a.img
          style={daenerysProps}
          id='daenerys'
          src={daenerys.sources['880w']}
          srcSet={daenerys.srcSet}
          sizes='50vw'
          alt=''
        />

        <a.img
          style={{
            transform: scrollTop.interpolate(
              val =>
                `translateZ(${75 - val * 75}px) translateY(${10 + val * 10}%)`
            )
          }}
          id='heer-mittelgrund'
          src={heerMittelgrund.sources['880w']}
          srcSet={heerMittelgrund.srcSet}
          sizes='110vw'
          alt=''
        />

        <a.img
          style={{
            transform: scrollTop.interpolate(
              val =>
                `translateZ(${100 - val * 80}px) translateY(${25 - val * 25}%)`
            )
          }}
          id='heer-vordergrund'
          src={heerVordergrund.sources['880w']}
          srcSet={heerVordergrund.srcSet}
          sizes='110vw'
          alt=''
        />

        <a.img
          style={{
            transform: scrollTop.interpolate(
              val =>
                `translateZ(${200 - val * 150}px) translateY(${45 - val * 45}%)`
            )
          }}
          id='felsen'
          src={felsen.sources['880w']}
          srcSet={felsen.srcSet}
          sizes='110vw'
          alt=''
        />
      </div>
    </div>
  )
}
